import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../../utils'

export const SET_PROFILEID_SELECTED = 'sherrinford/profile/detail/SET_PROFILEID_SELECTED'

export const GET_PROFILE_BY_ID_REQUEST = 'sherrinford/profile/detail/GET_PROFILE_BY_ID_REQUEST'
export const GET_PROFILE_BY_ID_SUCCESS = 'sherrinford/profile/detail/GET_PROFILE_BY_ID_SUCCESS'
export const GET_PROFILE_BY_ID_ERROR = 'sherrinford/profile/detail/GET_PROFILE_BY_ID_ERROR'

export const GET_FINANCEPROFILE_BY_PROFILEID_REQUEST = 'sherrinford/profile/detail/GET_FINANCEPROFILE_BY_PROFILEID_REQUEST'
export const GET_FINANCEPROFILE_BY_PROFILEID_SUCCESS = 'sherrinford/profile/detail/GET_FINANCEPROFILE_BY_PROFILEID_SUCCESS'
export const GET_FINANCEPROFILE_BY_PROFILEID_ERROR = 'sherrinford/profile/detail/GET_FINANCEPROFILE_BY_PROFILEID_ERROR'

export const GET_PROFILE_TAX_URL_REQUEST = 'sherrinford/profile/detail/GET_PROFILE_TAX_URL_REQUEST'
export const GET_PROFILE_TAX_URL_SUCCESS = 'sherrinford/profile/detail/GET_PROFILE_TAX_URL_SUCCESS'
export const GET_PROFILE_TAX_URL_ERROR = 'sherrinford/profile/detail/GET_PROFILE_TAX_URL_ERROR'

export const GET_FINANCE_PROFILE_TAX_URL_REQUEST = 'sherrinford/finance_profile/list/GET_FINANCE_PROFILE_TAX_URL_REQUEST'
export const GET_FINANCE_PROFILE_TAX_URL_SUCCESS = 'sherrinford/finance_profile/list/GET_FINANCE_PROFILE_TAX_URL_SUCCESS'
export const GET_FINANCE_PROFILE_TAX_URL_ERROR = 'sherrinford/finance_profile/list/GET_FINANCE_PROFILE_TAX_URL_ERROR'

export const GET_PROFILEBANK_BY_PROFILEID_REQUEST = 'sherrinford/profile/detail/GET_PROFILEBANK_BY_PROFILEID_REQUEST'
export const GET_PROFILEBANK_BY_PROFILEID_SUCCESS = 'sherrinford/profile/detail/GET_PROFILEBANK_BY_PROFILEID_SUCCESS'
export const GET_PROFILEBANK_BY_PROFILEID_ERROR = 'sherrinford/profile/detail/GET_PROFILEBANK_BY_PROFILEID_ERROR'

export const GET_PRODUCT_BY_PROFILEID_REQUEST = 'sherrinford/profile/detail/GET_PRODUCT_BY_PROFILEID_REQUEST'
export const GET_PRODUCT_BY_PROFILEID_SUCCESS = 'sherrinford/profile/detail/GET_PRODUCT_BY_PROFILEID_SUCCESS'
export const GET_PRODUCT_BY_PROFILEID_ERROR = 'sherrinford/profile/detail/GET_PRODUCT_BY_PROFILEID_ERROR'

export const GET_PROJECT_BY_PROFILE_REQUEST = 'sherrinford/profile/detail/GET_PROJECT_BY_PROFILE_REQUEST'
export const GET_PROJECT_BY_PROFILE_SUCCESS = 'sherrinford/profile/detail/GET_PROJECT_BY_PROFILE_SUCCESS'
export const GET_PROJECT_BY_PROFILE_ERROR = 'sherrinford/profile/detail/GET_PROJECT_BY_PROFILE_ERROR'

export const SET_SORT_PRODUCT_BY_PROFILE = 'sherrinford/profile/detail/SET_SORT_PRODUCT_BY_PROFILE'
export const SET_SORT_PROJECT_BY_PROFILE = 'sherrinford/profile/detail/SET_SORT_PROJECT_BY_PROFILE'
export const SET_FILTER_PROJECT_BY_PROFILE = 'sherrinford/profile/detail/SET_FILTER_PROJECT_BY_PROFILE'

export const SET_ADDRESS = 'sherrinford/finance_profile/list/SET_ADDRESS'

export const UPDATE_ADDRESS_FINANCE_REQUEST = 'sherrinford/finance_profile/list/UPDATE_ADDRESS_FINANCE_REQUEST'
export const UPDATE_ADDRESS_FINANCE_SUCCESS = 'sherrinford/finance_profile/list/UPDATE_ADDRESS_FINANCE_SUCCESS'
export const UPDATE_ADDRESS_FINANCE_FAILURE = 'sherrinford/finance_profile/list/UPDATE_ADDRESS_FINANCE_FAILURE'

export const CLEAR_PROPS = 'sherrinford/finance_profile/list/CLEAR_PROPS'

const initialState = {
  data: {
    users: [{
      id: '',
      email: '',
      firstName: '',
      lastName: '',
      source: '',
      createdAt: '',
      phoneNumber: '',
    }],
    name: '',
    profileId: '',
    about: '',
    id: '',
  },
  financeProfile: {
    count: 0,
    currentPage: 1,
    totalPages: 0,
    rows: [],
    qs: {
      skip: 0,
      limit: 10,
      sort: '',
    },
  },
  profilesBankInformation: {
    count: 0,
    currentPage: 1,
    totalPages: 0,
    rows: [],
    qs: {
      skip: 0,
      limit: 10,
      sort: '',
    },
  },
  productsProfile: {
    data: {
      count: 0,
      currentPage: 1,
      totalPages: 0,
      rows: [],
      qs: {
        skip: 0,
        limit: 25,
        sort: '',
      },
    },
    sort: {
      active: '',
      createdAt: 'ASC',
      updatedAt: 'ASC',
    },
  },
  projectsProfile: {
    data: {
      count: 0,
      currentPage: 1,
      totalPages: 0,
      rows: [],
      qs: {
        skip: 0,
        limit: 25,
        sort: '',
      },
    },
    filter: {
      status: null,
    },
    sort: {
      active: '',
      createdAt: 'ASC',
      updatedAt: 'ASC',
    },
    orderStatus: [
      'Invitation Sent',
      'Quote Generated',
      'PO Needed',
      'Invoice Received',
      'Project Running',
      'Completed',
      'Cancelled',
      'Expired',
      'Payment Needed',
    ],
  },
  isLoading: false,
  isUpdated: false,
  isError: false,
  isUpdatedError: false,
}

export default createReducer(initialState, {
  [GET_PROFILE_BY_ID_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_PROFILE_BY_ID_SUCCESS]: (state, data) => ({
    ...state,
    data,
    isLoading: false,
  }),
  [GET_PROFILE_BY_ID_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [GET_FINANCEPROFILE_BY_PROFILEID_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_FINANCEPROFILE_BY_PROFILEID_SUCCESS]: (state, financeProfile) => ({
    ...state,
    financeProfile,
    isLoading: false,
  }),
  [GET_FINANCEPROFILE_BY_PROFILEID_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [GET_PROFILE_TAX_URL_REQUEST]: state => ({
    ...state,
    isLoading: false,
  }),
  [GET_PROFILE_TAX_URL_SUCCESS]: (state, res) => ({
    ...state,
    data: {
      ...state.data,
      taxUrl: res.data?.p?.u,
    },
  }),
  [GET_PROFILE_TAX_URL_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [GET_FINANCE_PROFILE_TAX_URL_REQUEST]: state => ({
    ...state,
    isLoading: false,
  }),
  [GET_FINANCE_PROFILE_TAX_URL_SUCCESS]: (state, res) => ({
    ...state,
    financeProfile: {
      ...state.financeProfile,
      rows: [{
        ...state.financeProfile.rows[0],
        taxUrl: res.data?.fp?.u,
      },
      ],
    },
  }),
  [GET_FINANCE_PROFILE_TAX_URL_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [GET_PROFILEBANK_BY_PROFILEID_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_PROFILEBANK_BY_PROFILEID_SUCCESS]: (state, profilesBankInformation) => ({
    ...state,
    profilesBankInformation,
    isLoading: false,
  }),
  [GET_PROFILEBANK_BY_PROFILEID_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
  [GET_PRODUCT_BY_PROFILEID_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_PRODUCT_BY_PROFILEID_SUCCESS]: (state, productsProfile) => ({
    ...state,
    productsProfile: {
      ...state.productsProfile,
      data: productsProfile,
    },
    isLoading: false,
  }),
  [GET_PRODUCT_BY_PROFILEID_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
  [SET_SORT_PRODUCT_BY_PROFILE]: (state, data) => ({
    ...state,
    productsProfile: {
      ...state.productsProfile,
      sort: data,
    },
  }),
  [GET_PROJECT_BY_PROFILE_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [GET_PROJECT_BY_PROFILE_SUCCESS]: (state, projectsProfile) => ({
    ...state,
    projectsProfile: {
      ...state.projectsProfile,
      data: projectsProfile,
    },
    isLoading: false,
  }),
  [GET_PROJECT_BY_PROFILE_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),
  [SET_SORT_PROJECT_BY_PROFILE]: (state, data) => ({
    ...state,
    projectsProfile: {
      ...state.projectsProfile,
      sort: data,
    },
  }),
  [SET_FILTER_PROJECT_BY_PROFILE]: (state, data) => ({
    ...state,
    projectsProfile: {
      ...state.projectsProfile,
      filter: {
        ...data,
      },
    },
  }),
  [SET_ADDRESS]: (state, address) => ({
    ...state,
    financeProfile: {
      ...state.financeProfile,
      rows: [{
        ...state.financeProfile.rows[0],
        address,
      },
      ],
    },
  }),
  [UPDATE_ADDRESS_FINANCE_REQUEST]: state => ({
    ...state,
    isLoading: true,
    isUpdated: false,
    isUpdatedError: false,
  }),
  [UPDATE_ADDRESS_FINANCE_SUCCESS]: state => ({
    ...state,
    isLoading: false,
    isUpdated: true,
  }),
  [UPDATE_ADDRESS_FINANCE_FAILURE]: state => ({
    ...state,
    isLoading: false,
    isUpdatedError: true,
  }),
  [CLEAR_PROPS]: state => ({
    ...state,
    isLoading: false,
    isUpdated: false,
    isUpdatedError: false,
  }),
})

export const getProfileById = (profileId, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      GET_PROFILE_BY_ID_REQUEST,
      GET_PROFILE_BY_ID_SUCCESS,
      GET_PROFILE_BY_ID_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/profile/${profileId}`,
      authorization: `${token}`,
    },
    nextAction: res => cb(res),
  }
}

export const getFinanceProfileByProfileId = (profileId, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      GET_FINANCEPROFILE_BY_PROFILEID_REQUEST,
      GET_FINANCEPROFILE_BY_PROFILEID_SUCCESS,
      GET_FINANCEPROFILE_BY_PROFILEID_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/finance_profile?search={"profile":"${profileId}"}`,
      authorization: `${token}`,
    },
    nextAction: res => cb(res),
  }
}

export const getProfileTaxUrl = profileId => ({
  type: [
    GET_PROFILE_TAX_URL_REQUEST,
    GET_PROFILE_TAX_URL_SUCCESS,
    GET_PROFILE_TAX_URL_ERROR,
  ],
  shuttle: {
    method: 'POST',
    path: `/scr/${profileId}/p`,
    universeHost: true,
  },
})

export const getFinanceProfileTaxUrl = financeProfileId => ({
  type: [
    GET_FINANCE_PROFILE_TAX_URL_REQUEST,
    GET_FINANCE_PROFILE_TAX_URL_SUCCESS,
    GET_FINANCE_PROFILE_TAX_URL_ERROR,
  ],
  shuttle: {
    method: 'POST',
    path: `/scr/${financeProfileId}/fp`,
    universeHost: true,
  },
})

export const getProfileBankByProfileId = (profileId, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      GET_PROFILEBANK_BY_PROFILEID_REQUEST,
      GET_PROFILEBANK_BY_PROFILEID_SUCCESS,
      GET_PROFILEBANK_BY_PROFILEID_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/profile_bank_information?search={"profile":"${profileId}"}`,
      authorization: `${token}`,
    },
    nextAction: res => cb(res),
  }
}

export const getProductByProfileId = (profileId, payloads) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      GET_PRODUCT_BY_PROFILEID_REQUEST,
      GET_PRODUCT_BY_PROFILEID_SUCCESS,
      GET_PRODUCT_BY_PROFILEID_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/profile/${profileId}/product`,
      authorization: `${token}`,
      payloads,
    },
  }
}

export const getProjectByProfileId = (profileId, payloads) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      GET_PROJECT_BY_PROFILE_REQUEST,
      GET_PROJECT_BY_PROFILE_SUCCESS,
      GET_PROJECT_BY_PROFILE_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: `/profile/${profileId}/order`,
      authorization: `${token}`,
      payloads,
    },
  }
}

export const setSortProductByProfile = payload => ({
  type: [SET_SORT_PRODUCT_BY_PROFILE],
  payload,
})

export const setSortProjectByProfile = payload => ({
  type: [SET_SORT_PROJECT_BY_PROFILE],
  payload,
})

export const setFilterProjectByProfile = payload => ({
  type: [SET_FILTER_PROJECT_BY_PROFILE],
  payload,
})

export const setAddress = data => ({
  type: [SET_ADDRESS],
  payload: data,
})

export const updateAddressFinance = (idFinanceProfile, payloads) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      UPDATE_ADDRESS_FINANCE_REQUEST,
      UPDATE_ADDRESS_FINANCE_SUCCESS,
      UPDATE_ADDRESS_FINANCE_FAILURE,
    ],
    shuttle: {
      method: 'PUT',
      path: `/finance_profile/${idFinanceProfile}`,
      authorization: `${token}`,
      payloads,
    },
  }
}

export const clearProps = () => ({
  type: [CLEAR_PROPS],
})
